import { Box } from '@mui/material';
import RenderJsonField from '../components/ui/RenderJsonField';

function calculateColumnWidth(data, field, min = 150, max = 350) {
  if (!data.length) return min;

  const maxContentLength = data.reduce((maxLen, row) => {
    const value = row[field];
    if (value === null || value === undefined) return maxLen;
    const length = String(value).length;
    return length > maxLen ? length : maxLen;
  }, 0);

  let width = maxContentLength * 10;

  if (width < min) width = min;
  if (width > max) width = max;

  return width;
}

export const firebaseGridColumnGenerator = (defaultVisibleFields, data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const firstDataItem = data[0];
  const columnKeys = Object.keys(firstDataItem);

  const columns = columnKeys.map((key) => {
    const fieldConfig = defaultVisibleFields.find((field) => field.field === key);
    const isVisible = fieldConfig !== undefined;

    const dynamicWidth = calculateColumnWidth(data, key, 120, 300);

    return {
      field: key,
      headerName: key.charAt(0).toUpperCase() + key.slice(1),
      width: isVisible ? (fieldConfig.width || dynamicWidth) : dynamicWidth,
      minWidth: 120,
      renderCell: (params) => {
        const value = params.value;

        if (typeof value === 'object') {
          return (
            <RenderJsonField
              value={value}
            />
          );
        }

        if (typeof value === 'boolean') {
          return (
            <span>{String(value)}</span>
          );
        }

        return <Box
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
          }}
          title={value}
        >
          {value}
        </Box>;
      },
      verticalAlign: 'middle',
      headerAlign: 'center',
      align: 'center',
      editable: fieldConfig?.editable ?? false,
    };
  });

  return columns;
};
